import { CartRestService } from "./cart-rest.service";

/**
 * @deprecated
 */
export class CartRestServiceProvider {

    constructor() { }

    public $get = ["$rest", "runtimeContext", function CartRestServiceFactory($rest: qpmn.common.rest.IRestService, runtimeContext: qpmn.main.IRuntimeContext) {

        return new CartRestService($rest, runtimeContext);
    }]
}